/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_7cf32a11","_7cf32a11",""]'><div :class='["","_7cf32a11",""]'><div :class='["picker-demo-title","_7cf32a11",""]'>basic-picker:</div><cube-time-picker ref="__mpx_ref_picker__" :min="(min)" :max="(max)" :show-now="(showNow)" @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @change='(e)=>__invoke(e, [["onChange"]])' :class='["","_7cf32a11",""]'/><div :class='["button-wrapper","_7cf32a11",""]'><cube-button @_click="getSelected" :class='["","_7cf32a11",""]'>获取当前选中项</cube-button></div><div :class='["demo-data","_7cf32a11",""]' v-if="(selectedInfo.length || changeParams.length)"><template v-if="(selectedInfo.length)"><div :class='["key","_7cf32a11",""]'>getSelectedInfo 事件返回值：</div><div :class='["value","_7cf32a11",""]'><div v-for="(item, index) in (selectedInfo)" :key="item.index" :class='["value-item","_7cf32a11",""]'><div :class='["item-key","_7cf32a11",""]'>{{item[0]}}</div><div :class='["item-value","_7cf32a11",""]'>{{item[1]}}</div></div></div></template><template v-if="(changeParams.length)"><div :class='["key","_7cf32a11",""]'>change 事件参数：</div><div :class='["value","_7cf32a11",""]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item","_7cf32a11",""]'><div :class='["item-key","_7cf32a11",""]'>{{item[0]}}</div><div :class='["item-value","_7cf32a11",""]'>{{item[1]}}</div></div></div></template><template v-if="(changeParams.length)"><div :class='["key","_7cf32a11",""]'>columnChange 事件参数：</div><div :class='["value","_7cf32a11",""]'><div v-for="(item, index) in (columnChangeParams)" :key="item.index" :class='["","_7cf32a11",""]'><div :class='["value-number","_7cf32a11",""]'>第{{ index+1 }}次：</div><div v-for="(itemChild, index) in (item)" :key="itemChild.twoIndex" :class='["value-item","_7cf32a11",""]'><div :class='["item-key","_7cf32a11",""]'>{{itemChild[0]}}</div><div :class='["item-value","_7cf32a11",""]'>{{itemChild[1]}}</div></div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_7cf32a11"}'>
  .picker-demo-title
    margin-bottom 8px
</style>
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_7cf32a11"}'>
.button-wrapper
  margin-top: 10px
.picker-demo-title
  margin-bottom 8px
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        margin-left: 10px
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_7cf32a11"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_7cf32a11"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker7cf32a11%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker7cf32a11%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_7cf32a11"],
    ctorType: "component",
    outputPath: "components/basic-picker7cf32a11/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-time-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>